var lib_core = require("lib-core");
var ui_extensions = require("ui-extensions");

var OriginModel = require("./originModel.js");
var OriginView = require("./originView.js");
var Editor2DController = require("../editor2D/editor2DController.js");
var Camera2DController = require("../camera2D/camera2DController.js");
var cio_config = require("cio-config");

var OriginController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(OriginController, lib_core.Controller);
OriginController.inject = {
    editor2DController : Editor2DController,
    camera2DController : Camera2DController
};
if(ui_extensions.OptionsController) {
    OriginController.inject.optionsController = ui_extensions.OptionsController;
}

module.exports = OriginController;

OriginController.prototype.createModel = function () {
	var editorModel = this.editor2DController.getModel();
    var cameraModel = this.camera2DController.getModel();

    var originModel = new OriginModel(cameraModel, editorModel, null, this.configuration);

    //todo next line needs to go
    this.parent().getModel().origin = this.parent().getModel().value("origin", false);
    this.parent().getModel().origin(originModel);
    
    return originModel;
};

OriginController.prototype.createView = function () {
    console.assert(this.configuration.layers, "Invalid options for Origin extension.");
    console.assert(isNaN(this.configuration.layers.controllayer), "Invalid options for Origin extension.");
    console.assert(isNaN(this.configuration.layers.drawinglayer), "Invalid options for Origin extension.");

    var layers = this.configuration.layers;

    var view = new OriginView(this.root, this.parent().getView(), this.parent().getModel(), this.getModel(), layers, this.configuration);

    return view;
};

OriginController.prototype.afterBuild = function () {
    this.getView().draw();

    if(this.optionsController) {
        var elements = [];
        if(this.getModel().units.length > 1){
            elements.push({
                label         : 'Grid Pitch',
                type          : ui_extensions.InspectorInputType.VALUE_AND_UNIT,
                datamember    : this.getModel().grid_value,
                datatype      : cio_config.types.positive_float,
                unitmember    : this.getModel().grid_unit,
                allowed_units : this.getModel().units
            });
        } else {
            elements.push({
                label      : 'Grid Pitch',
                type       : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
                datamember : this.getModel().grid_value,
                datatype   : cio_config.types.positive_float,
                unit       : this.getModel().grid_unit()
            });
        }

        elements.push({
            label       : 'Grid Visible',
            type        : ui_extensions.InspectorInputType.CHECKBOX,
            datamember  : this.getModel().grid_show
        });

        this.optionsController.addOptionGroup(elements);
    }
};
